/**
 * Created by Timur on 21.08.2026
 */

const Merge2MissionRowView = function (row) {
    return Prefab.instantiate(bundles.merge.jsons[`merge2mission_row_view_${row.data.mission.logic.period}_prefab_json`], { mission: row.data.mission });
};
